import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.home');
@Component({
    selector: 'wiz-page-home',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.home/view.scss */
:host {
  display: block;
  width: 100%;
  height: 100vh;
  min-height: 100vh;
  overflow: hidden;
  background: #f5f7f4;
}

.jochwon-host {
  width: 100%;
  height: 100%;
  margin: 0;
  overflow: hidden;
}

.jochwon-frame {
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
  background: #f5f7f4;
}`],
})
export class PageHomeComponent { }

export default PageHomeComponent;